import AuthLayout from "layouts/authLayout/AuthLayout";
import { Col, Container, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { Footer, Header } from "stories";
import { FooterChildren, HeaderChildren } from "../auth_views";
import RequestPasswordCard from "./RequestPasswordCard/RequestPasswordCard";

const RequestPassword = () => {
  return (
    <AuthLayout headerSpacing>
      <Helmet>
        <title>Reset Password | Fundever</title>
      </Helmet>
      <Header>
        <HeaderChildren linkedTo={"/sign-in"} />
      </Header>
      <Container fluid>
        <Row>
          <Col md={{ span: 6, offset: 3 }}>
            <RequestPasswordCard />
          </Col>
        </Row>
      </Container>
      <Footer>
        <FooterChildren />
      </Footer>
    </AuthLayout>
  );
};

export default RequestPassword;
